<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <!-- <div class="page_title">
        {{ pageText[userRole].pageTitle }}
      <el-progress v-if="userRole === 'pharmacy'" class="progress" :percentage="55" :show-text="false" color="#2463FF" />
      </div> -->
        <div class="container onboarding">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>{{ pageText[userRole].pageTitle }}</h1>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>

        <!-- Radio buttons for Yes/No selection -->
         <div class="d-flex flex-col gap-3 mb-4">
            Do you use a robotic dispensing system?
            <el-radio-group v-model="showForm">
                <el-radio :label="true">Yes</el-radio>
                <el-radio :label="false">No</el-radio>
            </el-radio-group>
         </div>

            <el-form-item class="button_submit mb0 mt-auto" v-if="!showForm">
                    <el-button class="submit" type="blue" @click="skip">
                        Continue
                    </el-button>
                </el-form-item>

            <el-form v-show="showForm" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">

                <el-form-item :label="communityPharmacyInfo?.label ? communityPharmacyInfo.label : 'Which robotic dispensing system do you use?'" prop="roboticDispensingSystem">
                    <el-select popper-class="normal-select" class="w-100"
                        v-model="formsData.userForm.roboticDispensingSystem.value"
                        placeholder="Select Robotic Dispensing System" @change="handleForm"
                        :popper-append-to-body="true">
                        <el-option v-for="option in rdsSelectOptions" :key="option.label" :label="option.label"
                            :value="option.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item v-if="formsData.userForm.roboticDispensingSystem.value === 'Others'"
                    label="Other Robotic Dispensing System" prop="hasRoboticDispensingSystem_other" :required="true">
                    <el-input v-model="formsData.userForm.hasRoboticDispensingSystem_other.value"
                        placeholder="Enter Robotic Dispensing System you use"
                        @blur="checkFormValidation('userForm', true)"></el-input>
                </el-form-item>

                <el-form-item class="button_submit mb0 mt-auto">
                    <el-button class="submit" type="blue" @click="save('userForm')">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { IonButton, IonButtons, IonIcon, IonToolbar } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import formHooks from '@/hooks/form/form'

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        // const instance = getCurrentInstance();
        const showForm = ref(false);
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const { communityPharmacyAdditionalInfo } = $store.getters.pharmacyAdditionalInfo;
        const communityPharmacyInfo = communityPharmacyAdditionalInfo?.length > 0 ? communityPharmacyAdditionalInfo[0] : {};
        const rdsSelectOptions = communityPharmacyAdditionalInfo?.length > 0 ? communityPharmacyAdditionalInfo[0]?.values : [];

        const pageText = {
            pharmacy: {
                pageTitle: "Robotic Dispensing Software",
                formText: `Please provide relevant informations below`,
            },
        };

        const formsDataArray = {
            userForm: {}
        }

        const dataArray = {
            roboticDispensingSystem: {
                value: '',
            },
            hasRoboticDispensingSystem_other: {
                value: '',
            }
        }

        Object.assign(formsDataArray.userForm, dataArray);

        const goBack = () => {
            // const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: "auth_workEnvironment",
            });
        };

        const handleForm = () => {
            // console.log(formsData)
        }

        const skip = () => {
            $store.dispatch("addAuthPageBack", $route.name);
            $router.push({
                name: "intro",
            })
        }

        const save = (formName) => {
            if (formsData.userForm.roboticDispensingSystem.value) {
                formsRefs[formName].value.validate((valid) => {
                    
                    if (valid) {
                        
                        (async () => {
                            try {
                                const formValues = getFormValues(formName);
                                const selectedRds = formValues.roboticDispensingSystem;
                                const otherRds = formValues.hasRoboticDispensingSystem_other;
                                
                                // const selectedValue = rdsSelectOptions.find(option => option.label === selectedRds);
                              
                                const payload = [{
                                    values: [{
                                        value: selectedRds,
                                        other_value: otherRds ? otherRds : "",
                                    }],
                                    key: communityPharmacyInfo.key,
                                    field_type: communityPharmacyInfo.fieldType,
                                }];
                               
                                // if (payload.values[0].show_textbox && otherRds) {
                                //     payload.values[0].label = otherRds; // Use the "other" value if a textbox is shown.
                                // }
    
                                await $store.dispatch("SAVE_ADDITIONAL_PHARMACY_INFO", payload);
                                $router.push({
                                    name: "intro",
                                })
                            } catch (error) {
                                console.log("error submit!!", error);
                            }
                        })();
                    } else {
                        // setFormValidation(formName, false, false);
                        console.log("error submit!!");
                        return false;
                    }
                });
                
            } else {
                skip();
            }
        };

        onMounted(() => {
            setPageClassGlobal('global_community_pharmacy_information')
            setFormRefs();
        })

        const {
            // onFormMaskAccept,
            checkFormValidation,
            // setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray)

        return {
            formsData,
            goBack,
            save,
            skip,
            pageText,
            userRole,
            handleForm,
            communityPharmacyInfo,
            rdsSelectOptions,
            checkFormValidation,
            showForm
        }
    }
}
</script>